/* src/app/components/payroll/purchase-request/purchase-adjust-void-entry/purchase-adjust-void-entry.component.css */
::ng-deep ppl-dialog div.popup-dialog.position-dialog div.content.medium {
  width: 90vw;
  max-width: 90%;
}
::ng-deep ppl-dialog div.popup-dialog.position-dialog.limit-dialog-width div.content.medium {
  max-width: 65%;
}
::ng-deep p-calendar.error-border input {
  border: 1px solid red;
}
table td,
table th {
  border: none;
}
.required-marker {
  color: red;
}
.error-message {
  color: red;
  font-size: 12px;
  min-height: 16px;
}
.table-scroll-wrapper {
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  -webkit-overflow-scrolling: touch;
}
.purchase-adjust-table {
  table-layout: fixed;
  width: 100%;
  min-width: 1300px;
  font-size: 12px;
  border-collapse: separate;
  border-spacing: 0;
}
.purchase-adjust-table th,
.purchase-adjust-table td {
  border: none;
  padding: 8px 10px !important;
  vertical-align: top;
  word-break: break-word;
  overflow-wrap: anywhere;
}
.purchase-adjust-table tr {
  vertical-align: top !important;
}
.purchase-adjust-table th {
  font-weight: 600;
  line-height: 1.3;
}
.purchase-adjust-table .ant-select,
.purchase-adjust-table input.ant-input {
  font-size: 12px !important;
  width: 100% !important;
}
.purchase-adjust-table .ant-select-selector,
.purchase-adjust-table input.ant-input {
  height: 32px !important;
  min-height: 32px !important;
  box-sizing: border-box !important;
  padding: 0 11px !important;
  border-radius: 4px;
}
.purchase-adjust-table .ant-select-single .ant-select-selector .ant-select-selection-item,
.purchase-adjust-table .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
  line-height: 30px;
}
.purchase-adjust-table .previous-value {
  display: inline-block;
  width: 100%;
  word-break: break-word;
  line-height: 1.4;
  color: #333;
}
.save-row {
  margin-top: 16px;
  padding: 0 4px;
}
/*# sourceMappingURL=purchase-adjust-void-entry.component-3HCPQCS6.css.map */
